import type { SharedRebateProgramsStats } from "../../../api/generated";
import type { Hoid } from "../data";

import {
  createReportContext,
  type InferReport,
} from "../../../context/ReportContext";

const sharedRebatePrograms = createReportContext({
  subIb: "multi",
  status: "multi",
})<
  { subIb: string; status: string },
  {
    table: { rows: Hoid[]; totalCount: number };
    stats: SharedRebateProgramsStats;
    /** Export CSV — the api downloads the file and resolves with nothing. */
    csv: void;
  },
  {
    selected: { subIb: string[] | null; status: string[] | null };
    search: string;
    dateRange: { from: Date | null; to: Date | null };
    sortBy: string | null;
    sortOrder: "asc" | "desc" | null;
    page: number;
    pageSize: number;
  }
>();

export const {
  Provider: BaseSharedRebateProgramsProvider,
  useReportContext: useBaseSharedRebateProgramsContext,
} = sharedRebatePrograms;

export type SharedRebateProgramsParams = InferReport<
  typeof sharedRebatePrograms,
  "params"
>;
